// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-btn {\n    margin: 4px;\n}", "",{"version":3,"sources":["webpack://src/components/TooltipButton/TooltipButton.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf","sourcesContent":[".action-btn {\n    margin: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
